<div class="container-xxl gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="row gx-0">
        <div class="col-12 col-lg-6 mx-auto text-center">
            <h1 class="fs-md-39 fs-29 fw-700 text-primary" [innerHtml]="title | translate"></h1>
            @if (subtitle) {
                <p class="fs-16 fs-md-19" [innerHtml]="subtitle | translate"></p>
            }
        </div>
    </div>
</div>
